import Request from '../../../../src/core/gd/data/request'
import WorkWeekSchedule from "../../model2/work-week-schedule/work-week-schedule"

export default class ApiUser {

    constructor() {

    }

    static getDashboard(companyUserId: ID) {
        return new Request(this,'GET','user/'+companyUserId+'/dashboard');
    }

    static getTasks(companyId: ID, companyUserId: ID) {
        return new Request(this,'GET','tasks/user/'+companyId+"/"+companyUserId);
    }

    static getCompanyUserSettings(companyUserId: ID) {
        return new Request(this, 'GET', 'user/'+companyUserId+'/settings');
    }

    static update(userId: ID, payload: any) {
        return new Request(this, 'PUT', 'user/'+userId+'/update', payload);
    }

    static makeAdmin(userId: ID) {
        return this.update(userId, {
            companyRole: gd.const.company.role.MANAGER,
            isAdmin: true
        })
    }

    static revokeAdmin(userId: ID) {
        return this.update(userId, {
            isAdmin: false
        })
    }

    static updateCompanyRole(companyUserId: ID,
                             companyRole: any,
                             departmentId: ID,
                             reportsTo: any,
                             customFieldsData: any) {
        return new Request(this, 'PUT', 'user/'+companyUserId+'/settings/company-role', {
            companyRole: companyRole,
            department: departmentId,
            reportsTo: reportsTo,
            customFieldsData
        });
    }

    // not in use... delete ?
    // updateCompanyUserFinance(companyUserId, internal, external) {
    //     return new Request(this, 'PUT', 'user/'+companyUserId+'/settings/finance', {
    //         internal: internal,
    //         external: external
    //     });
    // }

    static updateWorkWeek(companyUserId: ID,
                          workweek: any,
                          mon: number,
                          tue: number,
                          wed: number,
                          thu: number,
                          fri: number,
                          sat: number,
                          sun: number) {
        return new Request(this, 'PUT', 'user/'+companyUserId+'/settings/workweek', {
            workweek: workweek,
            work_week_mon: mon,
            work_week_tue: tue,
            work_week_wed: wed,
            work_week_thu: thu,
            work_week_fri: fri,
            work_week_sat: sat,
            work_week_sun: sun
        });
    }

    static updateWorkWeekNew(companyUserId: ID, workWeekSchedule: WorkWeekSchedule) {
        return new Request(this, 'PUT', 'user/{0}/settings/workweek-v2'.f(companyUserId), workWeekSchedule.apiCallParams)
    }

    static updateDailyBadgeSettings(companyUserId: ID,
                                    isEnabled: boolean,
                                    timeReport: boolean,
                                    eventPastdue: number,
                                    taskAssingedDeadline: number,
                                    taskARNotScheuled: number,
                                    taskAssingedBehindSchedule: number) {
        return new Request(this, 'PUT', 'user/'+companyUserId+'/settings/daily-badge', {
            isEnabled: isEnabled,
            timeReport: timeReport,
            eventPastdue: eventPastdue,
            taskAssingedDeadline: taskAssingedDeadline,
            taskARNotScheuled: taskARNotScheuled,
            taskAssingedBehindSchedule: taskAssingedBehindSchedule
        });
    }

    static updateSettingsTimeTracking(companyUserId: ID, requiredTimeReportMinutes: number, guesstimate: number) {
        return new Request(this, 'PUT', 'user/'+companyUserId+'/settings/time-tracking', {
            requiredTimeReport: requiredTimeReportMinutes,
            guesstimate: guesstimate
        });
    }

    // not in use
    // static loginAs(companyId: ID, userId: ID) {
    //     return new Request(this, 'GET', 'company/'+companyId+'/login-as-user/'+userId);
    // }

    /*getScheduleAccess(companyUserId) {
        return new Request(this, 'GET', 'user/'+companyUserId+'/schedule-access');
    }*/

    static addToScheduleAccess(companyUserId: ID, users: any) {
        return new Request(this, 'POST', 'user/'+companyUserId+'/schedule-access', {users});
    }

    static removeFromScheduleAccess(companyUserId: ID, targetUserId: ID) {
        return new Request(this, 'DELETE', 'user/'+companyUserId+'/schedule-access/'+targetUserId);
    }

    static getCompanyUserCalendar(companyUserId: ID, year: number) {
        return new Request(this, 'GET', 'user/'+companyUserId+'/calendar', {year});
    }

    static getActivity(companyUserId: ID, monthRange: MomentRange) {
        return new Request(this, 'POST', 'user/{0}/activity'.f(companyUserId), {
            startMoment : monthRange.start,
            endMoment   : monthRange.end
        })
    }
}
